import { useCti } from "../Embedded/Hubspot/useCti.ts"

// For oAuth flows that should skip signin, calling initialisations for embedded apps and more such actions 
const SpecialEmbeddedBehaviour = (embedded) => {
    if (embedded) {
        if (embedded.toLowerCase() === "hubspot") {
            // Initialize SDK while in signin screen, otherwise Hubspot will treat the app as 'offline' and break
            if (!localStorage.getItem("securitytoken"))
                useCti(() => {}, () => {}, () => {});
        }
        if (embedded === "hubspotbonline") {
            let url = document.location.href
            url = url.replace("hubspotbonline","hubspot")
            url += "&brand=bonline&signinmethod=bonline"
            document.location.replace(url)
            return <div></div>
        }
    }
};

export default SpecialEmbeddedBehaviour;